export const ROUTES = {
  BUSINESS_ACCOUNT: '/business-account',
  CHARITIES: '/charities',
  CHARITY_ACCOUNT: '/charity-account',
  CHARITY_DASHBOARD: '/dashboard-charity',
}
